import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronGrabberHorizontalToward: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronGrabberHorizontalToward"><Path d="M10.6641 12L5.25 17.4141L3.83594 16L7.83594 12L3.83594 8L5.25 6.58594L10.6641 12Z" fill="currentColor"/><Path d="M20.1641 8L16.1641 12L20.1641 16L18.75 17.4141L13.3359 12L18.75 6.58594L20.1641 8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronGrabberHorizontalToward;
